import { forecastSchema } from './';

export const getRevenueForecast = `
  getRevenueForecast(season: $season) {
    ${forecastSchema}
  }`;



// WEBPACK FOOTER //
// ./src/api/revenue.js